module.exports = require("./ko.d.ts");